import { default as career_45pathwaysMsj9hJOUwDMeta } from "/opt/build/repo/pages/career-pathways.vue?macro=true";
import { default as career_45seeker_45interestljVIbLEMqJMeta } from "/opt/build/repo/pages/career-seeker-interest.vue?macro=true";
import { default as employer_45interest_45form0bWDvVVdrlMeta } from "/opt/build/repo/pages/employer-interest-form.vue?macro=true";
import { default as help_45desk_45ticketqlx1encD95Meta } from "/opt/build/repo/pages/help-desk-ticket.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as installationgxOdXUWDLoMeta } from "/opt/build/repo/pages/installation.vue?macro=true";
import { default as referral_45formqqgk0ga9ETMeta } from "/opt/build/repo/pages/referral-form.vue?macro=true";
import { default as success5PxaWcwlslMeta } from "/opt/build/repo/pages/success.vue?macro=true";
export default [
  {
    name: "career-pathways___en",
    path: "/career-pathways",
    component: () => import("/opt/build/repo/pages/career-pathways.vue")
  },
  {
    name: "career-pathways___es",
    path: "/es/career-pathways",
    component: () => import("/opt/build/repo/pages/career-pathways.vue")
  },
  {
    name: "career-seeker-interest___en",
    path: "/career-seeker-interest",
    component: () => import("/opt/build/repo/pages/career-seeker-interest.vue")
  },
  {
    name: "career-seeker-interest___es",
    path: "/es/career-seeker-interest",
    component: () => import("/opt/build/repo/pages/career-seeker-interest.vue")
  },
  {
    name: "employer-interest-form___en",
    path: "/employer-interest-form",
    component: () => import("/opt/build/repo/pages/employer-interest-form.vue")
  },
  {
    name: "employer-interest-form___es",
    path: "/es/employer-interest-form",
    component: () => import("/opt/build/repo/pages/employer-interest-form.vue")
  },
  {
    name: "help-desk-ticket___en",
    path: "/help-desk-ticket",
    component: () => import("/opt/build/repo/pages/help-desk-ticket.vue")
  },
  {
    name: "help-desk-ticket___es",
    path: "/es/help-desk-ticket",
    component: () => import("/opt/build/repo/pages/help-desk-ticket.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "installation___en",
    path: "/installation",
    component: () => import("/opt/build/repo/pages/installation.vue")
  },
  {
    name: "installation___es",
    path: "/es/installation",
    component: () => import("/opt/build/repo/pages/installation.vue")
  },
  {
    name: "referral-form___en",
    path: "/referral-form",
    component: () => import("/opt/build/repo/pages/referral-form.vue")
  },
  {
    name: "referral-form___es",
    path: "/es/referral-form",
    component: () => import("/opt/build/repo/pages/referral-form.vue")
  },
  {
    name: "success___en",
    path: "/success",
    component: () => import("/opt/build/repo/pages/success.vue")
  },
  {
    name: "success___es",
    path: "/es/success",
    component: () => import("/opt/build/repo/pages/success.vue")
  }
]